import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=17280af5&scoped=true&"
import script from "./Step4.vue?vue&type=script&lang=js&"
export * from "./Step4.vue?vue&type=script&lang=js&"
import style0 from "./Step4.vue?vue&type=style&index=0&id=17280af5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17280af5",
  null
  
)

export default component.exports